import { render, staticRenderFns } from "./terms-dialog.vue?vue&type=template&id=7c6574bc&"
import script from "./terms-dialog.vue?vue&type=script&lang=js&"
export * from "./terms-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports